





























import { ApiGroupBuyingOrderGroupOrderInfoResponse } from '@/api'
import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'
import { RequiredDeep } from 'vtils/types'

export default defineClassComponent<{
  data: RequiredDeep<ApiGroupBuyingOrderGroupOrderInfoResponse>
}>(
  {
    props: ['data'],
  },
  ({ props }) =>
    class {
      handleGoodsClick = () => {
        navigateTo('GoodsIndex', {
          id: props.data.commodityInfo.commodityId,
        })
      }
    },
)
